<template>
    <AppLayout>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
            <div class="widget widget-six">
                <projectMenu :project="project"></projectMenu>
                <div class="widget-content">
                    <div v-if="$page.props.errors">
                        <ul style="list-style-type: none; padding: 0" v-for="(error, key) in $page.props.errors"
                            :key="key">
                            <li class="alert alert-danger">{{ error }}</li>
                        </ul>
                    </div>
                    <div class="card-body">
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <h4 class="mb-1">Spędzony czas</h4>
                                    </div>
                                    <div class="d-flex align-items-center gap-2">
                                        <button type="button" class="btn btn-outline-primary" @click="refresh"
                                            :disabled="isLoading"><span v-if="isLoading"
                                                class="spinner-border spinner-border-sm me-1"></span>Pobierz produkcję</button>
                                        <button type="button" class="btn btn-outline-secondary" @click="refreshRCP"
                                            :disabled="isLoadingRcp"><span v-if="isLoadingRcp"
                                                class="spinner-border spinner-border-sm me-1"></span>Pobierz RCP</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="isLoading || isLoadingRcp" class="position-relative">
                            <div class="position-absolute w-100 h-100 text-center"
                                style="z-index: 9; min-height: 150px;">
                                <div class="spinner-border text-danger me-2 align-self-center loader-lg"
                                    style="margin-top: 50px;"></div>
                            </div>
                        </div>

                        <div :style="{ opacity: (isLoading || isLoadingRcp) ? '0.4' : '1' }">
                            <div class="row mb-3">
                                <div v-if="productionData" class="col-12 col-md-6">
                                    <div class="card border-0 shadow-sm h-100 bg-primary">
                                        <div class="card-body p-4">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <h6 class="text-white">Łączny czas produkcji ({{ productionData.suma_godzin ?? 0 }} h)</h6>
                                            </div>
                                            <div>
                                                <h5 class="text-white">{{ productionData.czas_dokladny ||
                                                    productionData.czas || '0 dni, 0 godzin, 0 minut' }}</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="rcpData" class="col-12 col-md-6">
                                    <div class="card border-0 shadow-sm h-100 bg-success">
                                        <div class="card-body p-4">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <h6 class="text-white">Łączny czas RCP ({{ rcpData.suma_godzin ?? 0 }} h)</h6>
                                            </div>
                                            <div>
                                                <h5 class="text-white">{{ rcpData.czas_dokladny || rcpData.czas || '0 dni, 0 godzin, 0 minut' }}</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="productionData?.koszyki?.length" class="row">
                                <div class="col-12">
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <h4 class="mb-0">Produkcja</h4>
                                        <small class="text-muted">{{ productionData.koszyki?.length ?? 0 }}
                                            rekordów</small>
                                    </div>
									  <ejs-grid
											id="GridProductionTime"
											ref="gridProductionTime"
											gridLines="Both"
											height="600px"
											:dataSource="productionGridData"
											:allowPaging="true"
											:pageSettings="pageSettings"
											:allowSorting="true"
											:allowFiltering="true"
											:filterSettings="filterOptions"
											:toolbar="toolbar"
											:allowReordering="true"
											:allowResizing="true"
											:showColumnChooser="true"
											:selectionSettings="selectionOptions"
											:allowSelection="true"
											:enablePersistence="false"
											:allowExcelExport="true"
											:toolbarClick="toolbarClick"
											:queryCellInfo="rcpQueryCellInfo"
											:editSettings="editSettings"
											:actionComplete="productionActionComplete"
											:rowHeight="32">
                                        <e-columns>
											<e-column
												field="id"
												headerText="ID"
												type="number"
												isPrimaryKey="true"
												:allowEditing="false"
												:visible="false"
											/>

											<e-column
												field="ID_Koszyk"
												headerText="Koszyk"
												type="number"
												:allowEditing="false"
												width="120"
											/> 
											<e-column field="Imie" :allowEditing="false" width="130" headerText="Imię"type="string"/>
                                            <e-column field="Nazwisko" :allowEditing="false" width="130" headerText="Nazwisko" type="string"/>
                                            <e-column field="DepartmentName" :allowEditing="false" width="180" headerText="Dział" type="string"/>
                                            <e-column field="Start" :allowEditing="true" headerText="Start" type="datetime" editType="datetimepickeredit" :edit="dateTimeEditParams" format="yyyy-MM-dd HH:mm:ss" width="220" headerTextAlign="Left"/>
                                            <e-column field="Koniec" :allowEditing="true" headerText="Koniec" width="220" type="datetime" editType="datetimepickeredit" :edit="dateTimeEditParams" format="yyyy-MM-dd HH:mm:ss" headerTextAlign="Left"/>
                                            <e-column field="czas" :allowEditing="false" headerText="Czas" width="250" type="string" headerTextAlign="Left"/>
                                            <e-column field="godziny" :allowEditing="false" headerText="Godziny" type="number" width="120" format="N2" headerTextAlign="Left"/>
                                            <e-column field="kwh_na_godzine" :allowEditing="false" headerText="kW/h" width="100" type="number" format="N2" headerTextAlign="Left"/>
                                            <e-column field="kwh" :allowEditing="false" headerText="Razem kW/h" width="120" type="number" format="N2" headerTextAlign="Left"/>
                                        </e-columns>
                                    </ejs-grid>
                                </div>
                            </div>
                            <div v-else-if="rcpData" class="row mt-4">
                                <div class="col-12">
                                    <div class="alert alert-secondary mb-0">
                                        Brak policzonych czasów produkcji tego projektu. Kliknij w przycisk
                                        <strong>Pobierz produkcję</strong>.
                                    </div>
                                </div>
                            </div>

                            <div v-if="rcpData?.rcp?.length" class="row mt-4">
                                <div class="col-12">
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <h4 class="mb-0">Wszystkie rekordy RCP</h4>
                                        <small class="text-muted">
                                            {{ rcpData.rcp.length }} rekordów
                                        </small>
                                    </div>
									<ejs-grid
										id="GridRcpRecords"
										ref="gridRcpRecords"
										gridLines="Both"
										height="500px"
										:dataSource="rcpRecordsGridData"
										:allowPaging="true"
										:pageSettings="pageSettings"
										:allowSorting="true"
										:allowFiltering="true"
										:filterSettings="filterOptions"
										:toolbar="rcpRecordsToolbar"
										:allowReordering="true"
										:allowResizing="true"
										:showColumnChooser="true"
										:selectionSettings="selectionOptions"
										:allowSelection="true"
										:enablePersistence="false"
										:allowExcelExport="true"
										:toolbarClick="toolbarClick"
										:queryCellInfo="rcpQueryCellInfo"
										:editSettings="editSettings"
										:actionComplete="rcpActionComplete"
										:rowHeight="32">
                                        <e-columns>
                                            <e-column field="ID_RCP" :allowEditing="false" headerText="ID"  width="80" type="number" :visible="false"/>
                                            <e-column field="Imie" :allowEditing="false" headerText="Imię" width="130" type="string"/>
                                            <e-column field="Nazwisko" :allowEditing="false" headerText="Nazwisko" width="130" type="string"/>
                                            <e-column field="DepartmentName" :allowEditing="false" headerText="Dział" width="180"type="string"/>
                                            <e-column field="StartTime" :allowEditing="true" headerText="Start" type="datetime" editType="datetimepickeredit" :edit="dateTimeEditParams" format="yyyy-MM-dd HH:mm:ss" width="220" headerTextAlign="Left"/>
                                            <e-column field="EndTime" :allowEditing="true" headerText="Koniec" width="220" type="datetime" editType="datetimepickeredit" :edit="dateTimeEditParams" format="yyyy-MM-dd HH:mm:ss" headerTextAlign="Left"/>
                                            <e-column field="czas" :allowEditing="false" headerText="Czas" width="280" type="string" headerTextAlign="Left"/>
                                            <e-column field="godziny" :allowEditing="false" headerText="Godziny" type="number" width="120" format="N2" headerTextAlign="Left"/>
                                            <e-column field="Comment" :allowEditing="false" headerText="Komentarz" type="string" headerTextAlign="Left"/>
                                        </e-columns>
                                    </ejs-grid>
                                </div>
                            </div>

                            <div v-if="rcpData?.podsumowanie_uzytkownikow?.length" class="row mt-4">
                                <div class="col-12">
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <h4 class="mb-0">Czas RCP według pracowników</h4>
                                        <small class="text-muted">{{ rcpData.podsumowanie_uzytkownikow.length }} pracowników</small>
                                    </div>
                                    <ejs-grid id="GridRcpUsers" ref="gridRcpUsers" gridLines="Both" height="400px"
                                        :dataSource="rcpUsersGridData" :allowPaging="true" :pageSettings="pageSettings"
                                        :allowSorting="true" :allowFiltering="true" :filterSettings="filterOptions"
                                        :toolbar="rcpUsersToolbar" :allowReordering="true" :allowResizing="true"
                                        :showColumnChooser="true" :selectionSettings="selectionOptions"
                                        :allowSelection="true" :enablePersistence="false" :allowExcelExport="true"
                                        :toolbarClick="toolbarClick" :rowHeight="32">
                                        <e-columns>
                                            <e-column field="UserID" headerText="User ID" type="number" isPrimaryKey="true" :visible="false"/>
                                            <e-column field="Imie" headerText="Imię" width="130" type="string"/>
                                            <e-column field="Nazwisko" headerText="Nazwisko" width="130"  type="string"/>
                                            <e-column field="DepartmentName" headerText="Dział" width="200" type="string"/>
                                            <e-column field="liczba_wpisow" headerText="Liczba wpisów" width="150"  type="number" headerTextAlign="Left"/>
                                            <e-column field="czas" headerText="Łączny czas" type="string"  width="280"headerTextAlign="Left"/>
                                            <e-column field="suma_godzin" headerText="Łącznie godzin"  width="150" type="number" format="N2" headerTextAlign="Left"/>
                                        </e-columns>
                                    </ejs-grid>
                                </div>
                            </div>

                            <div v-else-if="rcpData" class="row mt-4">
                                <div class="col-12">
                                    <div class="alert alert-secondary mb-0">
                                        Brak policzonych czasów RCP dla pracowników tego projektu. Kliknij w przycisk
                                        <strong>Pobierz RCP</strong>.
                                    </div>
                                </div>
                            </div>
							
                            <div v-if="productionDepartmentsGridData.length" class="row mt-4">
                                <div class="col-12">
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <h4 class="mb-0">Czas produkcji według działów</h4>
                                        <small class="text-muted">
                                            {{ productionDepartmentsGridData.length }} działów
                                        </small>
                                    </div>
                                    <ejs-grid id="GridProductionDepartments" ref="gridProductionDepartments"
                                        gridLines="Both" height="400px" :dataSource="productionDepartmentsGridData"
                                        :allowPaging="true" :pageSettings="pageSettings" :allowSorting="true"
                                        :allowFiltering="true" :filterSettings="filterOptions"
                                        :toolbar="productionDepartmentsToolbar" :allowReordering="true"
                                        :allowResizing="true" :showColumnChooser="true"
                                        :selectionSettings="selectionOptions" :allowSelection="true"
                                        :enablePersistence="false" :allowExcelExport="true" :toolbarClick="toolbarClick"
                                        :rowHeight="32">

										<e-columns>
										  <e-column field="DepartmentID" headerText="ID działu" type="number" :visible="false"/>
										  <e-column field="DepartmentName" headerText="Dział" type="string" />
										  <e-column field="produkcja_rekordow" headerText="Produkcja rekordów" type="number" headerTextAlign="Left" />
										  <e-column field="produkcja_godziny" headerText="Produkcja godzin" type="number" format="N2" headerTextAlign="Left" />
										  <e-column field="rcp_rekordow" headerText="RCP rekordów" type="number"  width="150" headerTextAlign="Left" />
										  <e-column field="rcp_godziny" headerText="RCP godzin" type="number"  width="150" format="N2" headerTextAlign="Left" />
										  <e-column field="godziny" headerText="Łącznie godzin" type="number"  width="150" format="N2" headerTextAlign="Left" />
										  <e-column field="czas" headerText="Łączny czas" type="string"  width="280" headerTextAlign="Left" />
										</e-columns>

                                    </ejs-grid>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import route from "../../../../../vendor/tightenco/ziggy/src/js/index.js";
import projectMenu from "@/Pages/Projects/parts/projectMenu.vue";
import {
    ColumnChooser,
    ColumnDirective,
    ColumnsDirective,
    ExcelExport,
    Filter,
    GridComponent,
    Page,
    Reorder,
    Resize,
    Sort,
    Toolbar,
	Edit
} from '@syncfusion/ej2-vue-grids';

export default {
    components: {
        AppLayout,
        projectMenu,
        'ejs-grid': GridComponent,
        'e-columns': ColumnsDirective,
        'e-column': ColumnDirective
    },
	
    props: {
        project: Object
    },
    data() {
        return {
			dateTimeEditParams: {
				params: {
					format: 'yyyy-MM-dd HH:mm:ss',
					step: 1
				}
			},
			editSettings: {
				allowEditing: true,
				allowAdding: false,
				allowDeleting: false,
				mode: 'Normal'
			},
            rcpRecordsGridData: [],
            productionDepartmentsGridData: [],
            isLoading: false,
            productionData: null,
            productionGridData: [],
            isLoadingRcp: false,
            rcpData: null,
            rcpUsersGridData: [],
            pageSettings: {
                pageSize: 20,
                pageSizes: [10, 20, 50, 100, 200]
            },
            filterOptions: {
                type: 'Excel'
            },
            toolbar: [
				{ text: 'Usuń', prefixIcon: 'e-delete', id: 'delete_btn' },
				'Update',
                {
                    text: 'Search',
                    prefixIcon: 'e-search',
					align: 'center',
                    id: 'search'
                },
                {
                    text: 'Eksport do Excela',
                    prefixIcon: 'e-excelexport',
                    id: 'GridProductionTime_excelexport'
                },
                'ColumnChooser'
            ],
            rcpUsersToolbar: [
                {
                    text: 'Search',
                    prefixIcon: 'e-search',
					align: 'center',
                    id: 'search'
                },
                {
                    text: 'Eksport pracowników do Excela',
                    prefixIcon: 'e-excelexport',
                    id: 'GridRcpUsers_excelexport'
                },
                'ColumnChooser'
            ],
            rcpRecordsToolbar: [
				{ text: 'Usuń', prefixIcon: 'e-delete', id: 'delete_btn2' },
				'Update',
                {
                    text: 'Search',
                    prefixIcon: 'e-search',
					align: 'center',
                    id: 'search'
                },
                {
                    text: 'Eksport rekordów do Excela',
                    prefixIcon: 'e-excelexport',
                    id: 'GridRcpRecords_excelexport'
                },
                'ColumnChooser'
            ],
            productionDepartmentsToolbar: [
                {
                    text: 'Search',
                    prefixIcon: 'e-search',
 					align: 'center',
                   id: 'search'
                },
                {
                    text: 'Eksport działów do Excela',
                    prefixIcon: 'e-excelexport',
                    id: 'GridProductionDepartments_excelexport'
                },
                'ColumnChooser'
            ],
            selectionOptions: {
                type: 'Single',
                mode: 'Row'
            }
        };
    },
    provide: {
        grid: [
            Page,
            Sort,
            Filter,
            Toolbar,
            Reorder,
            Resize,
            ColumnChooser,
            ExcelExport,
			Edit
        ]
    },
    mounted() {
        this.loadProductionTime();
    },
    methods: {
async productionActionComplete(args) {
    if (args.requestType !== 'save') {
        return;
    }

    await this.saveProductionRecord(args.data);
},

async rcpActionComplete(args) {
    if (args.requestType !== 'save') {
        return;
    }

    await this.saveRcpRecord(args.data);
},
async saveProductionRecord(row) {
    const payload = {
        id: Number(row.id),
        Start: this.formatDateForApi(row.Start),
        Koniec: this.formatDateForApi(row.Koniec),
    };

    try {
        const response = await axios.put(
            route('projects.production_time.update', {
                project: this.project.number
            }),
            payload
        );

        if (!response.data?.success) {
            throw new Error(
                response.data?.message ||
                'Nie udało się zapisać rekordu produkcji.'
            );
        }

        this.showSuccess('Rekord produkcji został zapisany.');

        await this.loadProductionTime();

    } catch (error) {
        this.showError(
            error,
            'Nie udało się zapisać rekordu produkcji.'
        );

        await this.loadProductionTime();
    }
},
async saveRcpRecord(data) {
    const payload = {
        ID_RCP: data.ID_RCP,
        StartTime: this.formatDateForApi(data.StartTime),
        EndTime: this.formatDateForApi(data.EndTime),
    };

    try {
        const response = await axios.put(
            route('projects.production_rcp_time.update', {
                project: this.project.number
            }),
            payload
        );

        if (!response.data?.success) {
            throw new Error(
                response.data?.message || 'Nie udało się zapisać rekordu RCP.'
            );
        }

        this.showSuccess('Rekord RCP został zapisany.');

        // Pobieramy aktualne dane i przeliczamy wszystkie sumy
        await this.loadProductionTime();

    } catch (error) {
        this.showError(
            error,
            'Nie udało się zapisać rekordu RCP.'
        );

        await this.loadProductionTime();
    }
},
formatDateForApi(value) {
    if (!value) {
        return null;
    }

    const date = value instanceof Date
        ? value
        : new Date(value);

    if (Number.isNaN(date.getTime())) {
        return null;
    }

    const pad = (number) => String(number).padStart(2, '0');

    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
        `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
},

		buildProductionDepartmentsSummary() {
			const productionRows = this.productionData?.koszyki || [];
			const rcpRows = this.rcpData?.rcp || [];

			const grouped = {};

			productionRows.forEach((item) => {
				const departmentId = Number(item.DepartmentID ?? 0);
				const departmentName = item.DepartmentName || 'Produkcja - inne';
				const key = String(departmentId);

				if (!grouped[key]) {
					grouped[key] = {
						DepartmentID: departmentId,
						DepartmentName: departmentName,
						produkcja_godziny: 0,
						rcp_godziny: 0,
						godziny: 0,
						produkcja_rekordow: 0,
						rcp_rekordow: 0,
						sekundy: 0
					};
				}

				const seconds = Number(item.sekundy || 0);
				const hours = Number(item.godziny || 0);

				grouped[key].produkcja_rekordow++;
				grouped[key].produkcja_godziny += hours;
				grouped[key].sekundy += seconds;
			});

			rcpRows.forEach((item) => {
				const departmentId = Number(item.DepartmentID ?? 0);
				const departmentName = item.DepartmentName || 'Produkcja - inne';
				const key = String(departmentId);

				if (!grouped[key]) {
					grouped[key] = {
						DepartmentID: departmentId,
						DepartmentName: departmentName,
						produkcja_godziny: 0,
						rcp_godziny: 0,
						godziny: 0,
						produkcja_rekordow: 0,
						rcp_rekordow: 0,
						sekundy: 0
					};
				}

				const hours = Number(item.godziny || 0);

				grouped[key].rcp_rekordow++;
				grouped[key].rcp_godziny += hours;
			});

			this.productionDepartmentsGridData = Object.values(grouped)
				.map((item, index) => {
					const totalHours =
						item.produkcja_godziny +
						item.rcp_godziny;

					const totalSeconds = Math.round(totalHours * 3600);

					const days = Math.floor(totalSeconds / 86400);
					const remainingAfterDays = totalSeconds % 86400;

					const hours = Math.floor(remainingAfterDays / 3600);
					const remainingAfterHours = remainingAfterDays % 3600;

					const minutes = Math.floor(remainingAfterHours / 60);
					const seconds = remainingAfterHours % 60;

					return {
						lp: index + 1,

						DepartmentID: item.DepartmentID,
						DepartmentName: item.DepartmentName,

						produkcja_rekordow: item.produkcja_rekordow,
						rcp_rekordow: item.rcp_rekordow,

						produkcja_godziny: Number(item.produkcja_godziny.toFixed(2)),
						rcp_godziny: Number(item.rcp_godziny.toFixed(2)),

						godziny: Number(totalHours.toFixed(2)),

						czas: `${days} dni, ${hours} godzin, ${minutes} minut, ${seconds} sekund`
					};
				})
				.sort((a, b) => b.godziny - a.godziny);
		},

        rcpQueryCellInfo(args) {
            if (args.column?.field !== 'godziny') {
                return;
            }

            const hours = Number(args.data?.godziny);

            if (Number.isNaN(hours)) {
                return;
            }

            if (hours > 24) {
                args.cell.style.backgroundColor = '#dc3545';
                args.cell.style.color = '#fff';
                args.cell.style.fontWeight = 'bold';
            } else if (hours > 15) {
                args.cell.style.backgroundColor = '#fd7e14';
                args.cell.style.color = '#fff';
                args.cell.style.fontWeight = 'bold';
            }
        },

        route,

        async loadProductionTime() {
            if (!this.project?.number) {
                console.error('Brak nazwy projektu.');
                return;
            }

            this.isLoading = true;
            this.isLoadingRcp = true;

            try {
                const [productionResult, rcpResult] = await Promise.allSettled([
                    axios.get(route('projects.production_time', {
                        project: this.project.number
                    })),
                    axios.get(route('projects.production_rcp_time', {
                        project: this.project.number
                    }))
                ]);

                if (productionResult.status === 'fulfilled') {
                    const response = productionResult.value;

                    if (response.data?.success) {
                        this.productionData = response.data;

                        this.productionGridData = (response.data.koszyki || []).map((item, index) => ({
                            lp: index + 1,
                            ...item
                        }));
						this.buildProductionDepartmentsSummary();
                    } else {
                        this.showError(
                            new Error(response.data?.message || 'Nie udało się pobrać danych czasu produkcji.'),
                            'Nie udało się pobrać danych czasu produkcji.'
                        );
                    }
                } else {
                    console.error('Błąd GET production:', productionResult.reason);
                    this.showError(
                        productionResult.reason,
                        'Nie udało się pobrać danych czasu produkcji.'
                    );
                }

                if (rcpResult.status === 'fulfilled') {
                    const response = rcpResult.value;

                    if (response.data?.success) {
                        this.rcpData = response.data;
                        this.rcpUsersGridData = (response.data.podsumowanie_uzytkownikow || []).map((item, index) => ({
                            lp: index + 1,
                            ...item
                        }));
                        this.rcpRecordsGridData = (response.data.rcp || []).map((item, index) => ({
                            lp: index + 1,
                            ...item
                        }));
						this.buildProductionDepartmentsSummary();
                    } else {
                        this.showError(
                            new Error(response.data?.message || 'Nie udało się pobrać danych RCP.'),
                            'Nie udało się pobrać danych RCP.'
                        );
                    }
                } else {
                    console.error('Błąd GET RCP:', rcpResult.reason);
                    this.showError(
                        rcpResult.reason,
                        'Nie udało się pobrać danych RCP.'
                    );
                }
            } finally {
                this.isLoading = false;
                this.isLoadingRcp = false;
            }
        },

        async refreshRCP() {
            if (!this.project?.number) {
                return;
            }
            this.isLoadingRcp = true;

            try {
                const [rcpResult] = await Promise.allSettled([
                    axios.get(route('projects.production_rcp_time.refresh', {
                        project: this.project.number
                    }))
                ]);
                if (rcpResult.status === 'fulfilled') {
                    const response = rcpResult.value;

                    if (response.data?.success) {
                        this.rcpData = response.data;
                        this.rcpUsersGridData = (response.data.podsumowanie_uzytkownikow || []).map((item, index) => ({
                            lp: index + 1,
                            ...item
                        }));
                        this.rcpRecordsGridData = (response.data.rcp || []).map((item, index) => ({
                            lp: index + 1,
                            ...item
                        }));
						this.buildProductionDepartmentsSummary();
                    } else {
                        this.showError(
                            new Error(response.data?.message || 'Nie udało się odświeżyć danych RCP.'),
                            'Nie udało się odświeżyć danych RCP.'
                        );
                    }
                } else {
                    console.error('Błąd POST RCP:', rcpResult.reason);
                    this.showError(
                        rcpResult.reason,
                        'Nie udało się odświeżyć danych RCP.'
                    );
                }
            } finally {
                this.isLoadingRcp = false;
            }
        },

        async refresh() {

            if (!this.project?.number) {
                return;
            }

            this.isLoading = true;

            try {
                const [productionResult] = await Promise.allSettled([
                    axios.get(route('projects.production_time.refresh', {
                        project: this.project.number
                    }))
                ]);

                if (productionResult.status === 'fulfilled') {
                    const response = productionResult.value;

                    if (response.data?.success) {
                        this.productionData = response.data;

                        this.productionGridData = (response.data.koszyki || []).map((item, index) => ({
                            lp: index + 1,
                            ...item
                        }));
						this.buildProductionDepartmentsSummary();
                    } else {
                        this.showError(
                            new Error(response.data?.message || 'Nie udało się odświeżyć danych czasu produkcji.'),
                            'Nie udało się odświeżyć danych czasu produkcji.'
                        );
                    }
                } else {
                    console.error('Błąd POST production:', productionResult.reason);
                    this.showError(
                        productionResult.reason,
                        'Nie udało się odświeżyć danych czasu produkcji.'
                    );
                }

            } finally {
                this.isLoading = false;
            }
        },

        showError(error, defaultMessage) {
            const message =
                error?.response?.data?.message ||
                error?.message ||
                defaultMessage;

            if (typeof Toast !== 'undefined') {
                Toast.fire({
                    position: 'top-end',
                    toast: true,
                    icon: 'error',
                    title: 'Błąd',
                    html: message,
                    showClass: {
                        popup: 'animate__animated animate__fadeInDown'
                    },
                    hideClass: {
                        popup: 'animate__animated animate__fadeOutUp'
                    },
                    timer: 3500,
                    timerProgressBar: true,
                    showConfirmButton: false,
                    showCloseButton: true
                });
            }
        },
		
		async deleteProductionRow(row) {
			if (!row?.id) {
				return;
			}

			try {
				const response = await axios.delete(
					route('projects.production_time.delete', {
						project: this.project.number,
						id: row.id
					})
				);

				if (!response.data?.success) {
					throw new Error(
						response.data?.message ||
						'Nie udało się usunąć rekordu produkcji.'
					);
				}

				this.showSuccess('Rekord produkcji został usunięty.');

				await this.loadProductionTime();

			} catch (error) {
				this.showError(
					error,
					'Nie udało się usunąć rekordu produkcji.'
				);
			}
		},
		
		async deleteRcpRow(row) {
			if (!row?.ID_RCP) {
				return;
			}

			try {
				const response = await axios.delete(
					route('projects.production_rcp_time.delete', {
						project: this.project.number,
						id: row.ID_RCP
					})
				);

				if (!response.data?.success) {
					throw new Error(
						response.data?.message ||
						'Nie udało się usunąć rekordu RCP.'
					);
				}

				this.showSuccess('Rekord RCP został usunięty.');

				await this.loadProductionTime();

			} catch (error) {
				this.showError(
					error,
					'Nie udało się usunąć rekordu RCP.'
				);
			}
		},
				showSuccess(message) {
			if (typeof Toast !== 'undefined') {
				Toast.fire({
					position: 'top-end',
					toast: true,
					icon: 'success',
					title: message,
					showClass: {
						popup: 'animate__animated animate__fadeInDown'
					},
					hideClass: {
						popup: 'animate__animated animate__fadeOutUp'
					},
					timer: 2500,
					timerProgressBar: true,
					showConfirmButton: false,
					showCloseButton: true
				});
			}
		},
        toolbarClick(args) {
			if (args.item.id === 'delete_btn') {
				const grid = this.$refs.gridProductionTime?.ej2Instances;

				if (!grid) {
					return false;
				}

				const selectedRow = grid.getSelectedRecords()?.[0];

				if (!selectedRow) {
					this.showError(
						new Error('Najpierw zaznacz rekord do usunięcia.'),
						'Nie wybrano rekordu.'
					);
					return false;
				}

				Toast.fire({
					toast: false,
					icon: 'warning',
					title: 'Usuwanie rekordu',
					html: `Na pewno chcesz usunąć wybrany rekord?`,
					showDenyButton: true,
					timer: false,
					position: 'center',
					showConfirmButton: true,
					confirmButtonText: 'Tak, usuń!',
					denyButtonText: 'Nie'
				}).then((result) => {
					if (result.isConfirmed) {
						this.deleteProductionRow(selectedRow);
					}
				});

				return false;
			}	
		
			if (args.item.id === 'delete_btn2') {
				const grid = this.$refs.gridRcpRecords?.ej2Instances;

				if (!grid) {
					return false;
				}

				const selectedRow = grid.getSelectedRecords()?.[0];

				if (!selectedRow) {
					this.showError(
						new Error('Najpierw zaznacz rekord RCP do usunięcia.'),
						'Nie wybrano rekordu.'
					);
					return false;
				}

				Toast.fire({
					toast: false,
					icon: 'warning',
					title: 'Usuwanie rekordu RCP',
					html: `Na pewno chcesz usunąć wybrany rekord?`,
					showDenyButton: true,
					timer: false,
					position: 'center',
					showConfirmButton: true,
					confirmButtonText: 'Tak, usuń!',
					denyButtonText: 'Nie'
				}).then((result) => {
					if (result.isConfirmed) {
						this.deleteRcpRow(selectedRow);
					}
				});

				return false;
			}
		
            if (args.item.id === 'GridRcpRecords_excelexport') {
                const grid = this.$refs.gridRcpRecords?.ej2Instances;

                if (!grid) {
                    return;
                }

                grid.excelExport({
                    fileName: `czas_rcp_rekordy_${this.project?.number || 'projekt'}.xlsx`
                });

                return;
            }

            if (args.item.id === 'GridProductionTime_excelexport') {
                const grid = this.$refs.gridProductionTime?.ej2Instances;

                if (!grid) {
                    return;
                }

                grid.excelExport({
                    fileName: `czas_produkcji_${this.project?.number || 'projekt'}.xlsx`
                });

                return;
            }

            if (args.item.id === 'GridRcpUsers_excelexport') {
                const grid = this.$refs.gridRcpUsers?.ej2Instances;

                if (!grid) {
                    return;
                }

                grid.excelExport({
                    fileName: `czas_rcp_pracownicy_${this.project?.number || 'projekt'}.xlsx`
                });
            }
            if (args.item.id === 'GridProductionDepartments_excelexport') {
                const grid = this.$refs.gridProductionDepartments?.ej2Instances;

                if (!grid) {
                    return;
                }

                grid.excelExport({
                    fileName: `czas_produkcji_dzialy_${this.project?.number || 'projekt'}.xlsx`
                });
            }
        }
    }
};
</script>